module.exports = __webpack_public_path__ + "static/media/oops.f80df95c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oops.svg
// module id = 1297
// module chunks = 1